import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const tallyTableTransactionCountSlice = createSlice({
  name: "getDriverDetailsWithId",
  initialState: {
    OATally: 0,
    HMTally: 0,
    error: null,
    isLoading: false,
  },
  reducers: {
    updateOATallyCount: (state, action) => {
      state.OATally = action.payload;
    },
  },
});
export const tallyTableTransactionCount = tallyTableTransactionCountSlice.reducer;
export const updateOATallyCount = tallyTableTransactionCountSlice.actions.updateOATallyCount;
